import CommonIntegrationPage from 'components/Integration/pages/CommonIntegrationPage'

import HelpCenterPage from './pages/HelpCenter'
import InstallPage from './pages/install'

import Drip from './services/Drip'
import FacebookAnalytics from './services/FacebookAnalytics'
import LeanData from './services/LeanData'
import Stripe from './services/Stripe'
import FullStory from './services/FullStory'
import Linkedin from './services/Linkedin'
import HubSpot from './services/HubSpot'
import Intercom from './services/Intercom'
import Salesforce from './services/Salesforce'
import Slack from './services/Slack'
import Zapier from './services/Zapier'
import WordPress from './services/WordPress'
import Outreach from './services/Outreach'
import MarketoIntegrationPage from './pages/MarketoIntegrationPage/index'
import GoogleAnalyticsIntegrationPage from './pages/GoogleAnalyticsIntegrationPage/index'
import MarketoConfigPage from './pages/MarketoConfigPage/index'
import Demandbase from './services/Demandbase/index'
import Vidyard from './services/Vidyard'
import MadKudu from './services/MadKudu'
import ClearbitPage from './pages/ClearbitPage'

import SalesforceEduTooltip from './components/SalesforceEduTooltip'
import MarketoEduTooltip from './components/MarketoEduTooltip'

const logoSrc = {
  fullstory: require('images/logos/fullstory-icon.png'),
  drip: require('images/svg/drip-logo-full.svg'),
  facebook: require('!svg-inline?removeTags=true!images/logos/facebook.svg'),
  googleanalytics: require('images/logos/google-analytics-logo.svg'),
  hubspot: require('images/hubspot-logo.png'),
  intercom: require('!svg-inline?removeTags=true!images/logos/Intercom.svg'),
  linkedin: require('images/svg/linkedin_logo_full.svg'),
  slack: require('images/logos/slack.svg'),
  salesforce: require('images/svg/salesforce-logo.svg'),
  zapier: require('images/zapier-logo.png'),
  wordpress: require('images/logos/wordpress-text-logo.svg'),
  marketo: require('images/logos/marketo-logo-text.png'),
  demandbase: require('images/logos/demandbase-logo-text.svg'),
  vidyard: require('images/logos/vidyard-logo-text.png'),
  madkudu: require('images/logos/madkudu-logo-text.svg'),
  outreach: require('images/logos/outreach-logo-text.svg'),
  leandata: require('!svg-inline?removeTags=true!images/logos/facebook.svg'),
}

export const INTEGRATIONS_URL = '/settings2/integrations'
export const BACK_LINK_TEXT = 'All integrations'

export const Pages = {
  knowledgebase: {
    title: 'Knowledgebase',
    description: 'Pair your knowledgebase with Drift’s intelligent messaging',
    Page: HelpCenterPage,
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL
  },
  install: {
    title: 'Install',
    description: 'Install Drift on your website in minutes',
    Page: InstallPage,
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL
  },
  drip: {
    title: 'Drip',
    description: '',
    logo: logoSrc.drip,
    Page: CommonIntegrationPage,
    Service: Drip,
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL
  },
  fullstory: {
    title: 'FullStory',
    description: '',
    logo: logoSrc.fullstory,
    Page: CommonIntegrationPage,
    Service: FullStory,
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL
  },
  googleAnalytics: {
    title: 'Google Analytics',
    description: '',
    logo: logoSrc.googleanalytics,
    Page: CommonIntegrationPage,
    Service: GoogleAnalyticsIntegrationPage,
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    serviceClassName: 'common-integration-page-logo-wide'
  },
  hubspot: {
    title: 'HubSpot',
    description: '',
    logo: logoSrc.hubspot,
    Page: CommonIntegrationPage,
    Service: HubSpot,
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL
  },
  linkedin: {
    title: 'LinkedIn',
    description: '',
    logo: logoSrc.linkedin,
    Page: CommonIntegrationPage,
    Service: Linkedin,
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    hideDisconnectButton: true
  },
  intercom: {
    title: 'Intercom',
    description: '',
    logo: logoSrc.intercom,
    Page: CommonIntegrationPage,
    Service: Intercom,
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL
  },
  slack: {
    title: 'Slack',
    description: '',
    logo: logoSrc.slack,
    Page: CommonIntegrationPage,
    Service: Slack,
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL
  },
  salesforce: {
    title: 'Salesforce',
    description: '',
    logo: logoSrc.salesforce,
    Page: CommonIntegrationPage,
    Service: Salesforce,
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    eduTooltip: SalesforceEduTooltip
  },
  zapier: {
    title: 'Zapier',
    description: '',
    logo: logoSrc.zapier,
    Page: CommonIntegrationPage,
    Service: Zapier,
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL
  },
  wordpress: {
    title: 'WordPress',
    description: '',
    logo: logoSrc.wordpress,
    Page: CommonIntegrationPage,
    Service: WordPress,
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    serviceClassName: 'common-integration-page-logo-very-wide'
  },
  marketo: {
    title: 'Marketo',
    description: '',
    logo: logoSrc.marketo,
    Page: CommonIntegrationPage,
    Service: MarketoIntegrationPage,
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    eduTooltip: MarketoEduTooltip
  },
  'marketo-config': {
    title: 'Marketo',
    description: '',
    Page: CommonIntegrationPage,
    Service: MarketoConfigPage,
    backLinkText: 'Marketo V2 Integration',
    backLinkUrl: '/settings/setup/marketo'
  },
  'demandbase': {
    title: 'Demandbase',
    description: '',
    logo: logoSrc.demandbase,
    Page: CommonIntegrationPage,
    Service: Demandbase,
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    serviceClassName: 'demandbase-integration-page'
  },
  madkudu: {
    title: 'MadKudu',
    description: '',
    logo: logoSrc.madkudu,
    Page: CommonIntegrationPage,
    Service: MadKudu,
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
  },
  vidyard: {
    title: 'Vidyard',
    description: '',
    logo: logoSrc.vidyard,
    Page: CommonIntegrationPage,
    Service: Vidyard,
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    hideDisconnectButton: true
  },
  clearbit: {
    title: 'Clearbit',
    description: '',
    Page: ClearbitPage,
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL
  },
  outreach: {
    title: 'Outreach',
    description: '',
    logo: logoSrc.outreach,
    Page: CommonIntegrationPage,
    Service: Outreach,
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    serviceClassName: 'common-integration-page-logo-wide outreach-integration-page',
    incompleteInstallEndpoint: '/integrations/outreach/install_status/internal',
  },
  facebookAnalytics: {
    title: 'Facebook Analytics',
    description: '',
    Page: FacebookAnalytics,
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL
  },
  leandata: {
    title: 'LeanData',
    description: '',
    Page: LeanData,
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL
  },
  stripe: {
    title: 'Stripe Payments',
    description: '',
    Page: Stripe,
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL
  },
}



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/PageConstants.js